import { useEffect } from 'react';
import type { FC } from 'react';
import { Helmet } from 'react-helmet-async';

import { Box, Card, CardContent, Grid, Link } from '@material-ui/core';
import { LoginAmplify } from '../components/auth/login-amplify';
import { LoginAuth0 } from '../components/auth/login-auth0';
import { LoginFirebase } from '../components/auth/login-firebase';
import { LoginJwt } from '../components/auth/login-jwt';
import { useAuth } from '../hooks/use-auth';
import gtm from '../lib/gtm';

export const Login: FC = () => {
  const year = new Date().getFullYear();
  const { method } = useAuth() as any;

  useEffect(() => {
    gtm.push({ event: 'page_view' });
  }, []);

  return (
    <>
      <Helmet>
        <title>Login | ServCare</title>
      </Helmet>
      <Box style={{
        height: '100%',
      }}
      >

        <Grid
          container
          style={{
            height: '100%'
          }}
        >
          <Grid
            item
            xs={12}
            sx={{
              padding: 2,
              backgroundImage: 'url(https://servcare-public-assets.s3.ap-south-1.amazonaws.com/web-login-background.png)',
              backgroundSize: 'contain',
            }}
          >
            <Card
              sx={{
                backgroundColor: 'background.default',
                maxWidth: '25rem',
                margin: 'auto',
                marginTop: '8%',
              }}
              variant="elevation"
              elevation={15}
            >
              <CardContent>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    pt: 3,
                    pb: 2
                  }}
                >
                  <img
                    src="/servcare-logo-dark.png"
                    alt="logo"
                    width="220px"
                  />
                </Box>
                {method === 'Amplify' && <LoginAmplify />}
                {method === 'Auth0' && <LoginAuth0 />}
                {method === 'Firebase' && <LoginFirebase />}
                {method === 'JWT' && <LoginJwt />}
              </CardContent>
            </Card>
            <Grid
              container
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                pb: 4
              }}
            >
              <Grid
                item
                xs={6}
                sx={{
                  display: 'flex',
                  justifyContent: 'center'
                }}
              >
                <Link
                  color="white"
                  href="https://www.muskmelon.com/"
                  target="_blank"
                  underline="none"
                  variant="body2"
                  sx={{
                    mt: 2
                  }}
                >
                  ©
                  {' '}
                  {year}
                  {' '}
                  Muskmelon Envtech Pvt. Ltd.
                </Link>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

      </Box>

    </>
  );
};
